import * as blocks from '@fremcast/section/blocks';
export default {
  computed: {
    fetchData() {
      const blockSelected = blocks.default.data[this.sectionSelected.type];
      const blockFields = _.get(this.sectionSelected, blockSelected.dataKey);
      // Workaroud: Since single block needs to go thru a loop at least once
      // @todo: Change validation against checking if blockfields is Array instead.
      return blockFields;
    }
  },
  methods: {
    fetchSectionBlock(type) {
      return blocks.default.data[type].name;
    }
  }
}